import React from 'react';
import styled from 'styled-components/macro';
import { Avatar, Row, Col } from 'antd';

import Button from 'components/Button/Button';
import Description from 'components/Description/Description';
import Heading from 'components/Heading/Heading';
import { buildHostProfileRoute, buildHostProfileListingRoute } from 'utils/routes';

import ArtezLogo from './images/artez.png';
import HoliLogo from './images/holi.png';
import PerfectHostLogo from './images/perfecthost.png';
import RentradiseLogo from './images/rentradise.png';
import TianXiaLogo from './images/tianxia.png';

const StyledAvatar = styled(Avatar)`
  background-color: ${props => props.theme.color.white} !important;
  height: 150px !important;
  max-width: 150px !important;

  @media (min-width: 992px) {
    height: auto !important;
    width: 100% !important;
  }
`;
StyledAvatar.displayName = 'StyledAvatar';

const StyledContainer = styled(Row)`
  height: 100% !important;
  padding-top: 8% !important;

  @media (min-width: 768px) {
    flex-direction: column !important;
  }
`;

const StyledColumn = styled(Col)`
  text-align: center;
  @media (min-width: 768px) {
    margin-bottom: 24px !important;
  }

  :hover {
    cursor: pointer;
  }
`;

// Temporary hardcoded here, TBC for dynamic or move to backend.
const PRESET_PLATINUM_HOSTS = {
  artez: '5e1c1e20b804907b01843af1',
  holi: '5e1b21aab804907b01843a99',
  perfecthost: '5e1c1ea2b804907b01843af5',
  rentradise: '5e1c19cfb804907b01843ae2',
  tianxia: '5e1c46e9b804907b01843b30'
};

const FeaturedHosts = ({ history }) => (
  <>
    <StyledContainer type="flex">
      <Heading as="h4" size="sub" color="black" align="center">
        OUR HOST PARTNERS
      </Heading>
      <Row type="flex" gutter={48} justify="center" align="top">
        <StyledColumn span={24} md={24} xl={4} onClick={() => history.push(buildHostProfileRoute(PRESET_PLATINUM_HOSTS.artez))}>
          <StyledAvatar src={ArtezLogo} size={150} />
          <Description align="center" bold>
            Artez Group
          </Description>
          <Description align="center" size="small">
            Managing 4 hotels and over 200 short stay units in Klang Valley. <br />
            Key portfolio: <br />
            Resort Suites, Dorsett Residences, and Velocity
          </Description>
        </StyledColumn>
        <StyledColumn span={24} md={24} xl={4} onClick={() => history.push(buildHostProfileRoute(PRESET_PLATINUM_HOSTS.holi))}>
          <StyledAvatar src={HoliLogo} size={150} />
          <Description align="center" bold>
            Holi Hospitality
          </Description>
          <Description align="center" size="small">
            Managing around 100 units in Johor area. <br />
            Key portfolio: <br />
            R&F Princess Cove, Suasana and 1-Medini
          </Description>
        </StyledColumn>
        <StyledColumn span={24} md={24} xl={4} onClick={() => history.push(buildHostProfileRoute(PRESET_PLATINUM_HOSTS.perfecthost))}>
          <StyledAvatar src={PerfectHostLogo} size={150} />
          <Description align="center" bold>
            Perfect Host
          </Description>
          <Description align="center" size="small">
            Managing over 200 units in whole Malaysia. <br />
            Key portfolio: <br />
            Banyan Tree Residences
          </Description>
        </StyledColumn>
        <StyledColumn span={24} md={24} xl={4} onClick={() => history.push(buildHostProfileRoute(PRESET_PLATINUM_HOSTS.rentradise))}>
          <StyledAvatar src={RentradiseLogo} size={150} />
          <Description align="center" bold>
            RentRadise
          </Description>
          <Description align="center" size="small">
            Managing around 100 units in Johor. <br />
            Superhost with 15000 reviews in Airbnb
          </Description>
        </StyledColumn>
        <StyledColumn span={24} md={24} xl={4} onClick={() => history.push(buildHostProfileRoute(PRESET_PLATINUM_HOSTS.tianxia))}>
          <StyledAvatar src={TianXiaLogo} size={150} />
          <Description align="center" bold>
            TianXia Management
          </Description>
          <Description align="center" size="small">
            Managing around 50 units in Ipoh, Perak.
            <br />
            Key portfolio:
            <br /> Octagon in the heart of Ipoh town.
          </Description>
        </StyledColumn>
      </Row>
      <Row type="flex" justify="center" style={{ width: '100%' }}>
        <Button type="cta" size="large" toUrl={buildHostProfileListingRoute()}>
          View All
        </Button>
      </Row>
    </StyledContainer>
  </>
);

export default FeaturedHosts;
